/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "thunder." + ({"0":"prizelist","1":"vippay"}[chunkId]||chunkId) + ".min.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "http://img.vip.kanimg.com/lib/thunderjs/1.7.4/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
var backDiv = null,
    popDiv = null;
var msgbox_tpl = __webpack_require__(13);
var active_cfg = window.active_cfg;
function showmsg(msg, opts) {
    exit();
    opts = opts || {};
    $('#act_msgbox_common').length ? popDiv = $('#act_msgbox_common') : popDiv = createpopDiv();
    var btn_title = (opts.btn_title)|| opts.title || '确定';
    var btn_class = (opts.btn_class) || '';
    var btn_payid = (opts.btn_payid || opts.pid) || '';
    var fn = opts.fn || opts.btn_fn || '';
    if (btn_payid) {
        btn_payid = 'pid="' + btn_payid + '"';
    }
    if(fn) {
        opts.btn_href = opts.btn_href || 'javascript:;';
    }
    var btn_href = (opts.btn_href) || 'javascript:msgExit()';
    var btn_target = (opts.btn_target == 1) ? '_blank' : '';
    var clickid = "";
    if (opts['boxTitle']) {
        opts['boxTitle'] ? opts['boxTitle'] = opts['boxTitle'] : opts['boxTitle'] = '温馨提示';
        popDiv.find('[name=boxTitle]').html(opts['boxTitle']);
    } else {
        popDiv.find('[name=boxTitle]').html('温馨提示');
    }

    popDiv.find("[name=msgbox_info]").html(msg);
    var btn = popDiv.find('[name=box_btn]');
    btn.replaceWith('<a class="act-pop-btn act-pop-btn-hot ' + btn_class + '" ' + clickid + ' ' + btn_payid + ' href="' + btn_href + '" name="box_btn" title="' + btn_title + '" target="' + btn_target + '">' + btn_title + '</a>');
    if (opts && opts['close_href']) { //修改点击关闭的操作
        var btn = popDiv.find('a.act-pop-close');
        btn.replaceWith('<a href="' + opts['close_href'] + '" title="关闭" class="act-pop-close act_close_box">关闭</a>');
    }
    popDiv.find('[name=box_btn]').on('click', function(){
        fn && fn();
    });
    createBackground(opts);
    popDiv.show();
    if (backDiv) {
        backDiv.show();
    }
    refreshBind();
};
/**
 * 显示指定id的div
 * 调用方式：showDiv('showdiv',{opacity:0});
 */
showmsg.show = function(id, opts) {
    exit();
    opts = opts || {};
    popDiv = $('#' + id);
    popDiv.show();
    createBackground(opts);
    if (backDiv) {
        backDiv.show();
    }
    if(opts.only) {
        refreshBackground();
    } else {
        refreshBind();
    }
};

showmsg.showErrorMsg = function(MSGID, opts) {
    if (active_cfg && active_cfg['msg']) {
        var MSG = active_cfg['msg'][MSGID];
    }
    if (MSG) {
        opts = {
            btn_title: MSG['btn_text'],
            btn_href: MSG['btn_link'],
            btn_target: MSG['btn_action'],
            boxTitle: MSG['title'],
            btn_class: MSG['btn_class'],
            btn_payid: MSG['btn_payid']
        };
        showmsg(MSG['content'], opts);
    } else {
        showmsg(MSGID, opts);
    }
}

function exit() {
    if (popDiv) popDiv.hide();
    if (backDiv) backDiv.remove();
};

function createpopDiv(opts) {
    var style = (opts && opts.style) || 'common';
    switch (style) {
        case 'common':
            popDiv = $(msgbox_tpl);
            popDiv.appendTo('body');
            break;
        default:
            break;
    }
    return popDiv;
}

/**
 * 创建背景层
 * 如果有指定背景层的id则直接显示该层
 */
function createBackground(opts) {
    var opacity = (opts && opts.opacity) == undefined ? 40 : opts.opacity;
    if (opacity > 0) {
        backDiv = $('<div></div>');
        backDiv.css({
            backgroundColor: "black",
            minWidth: '960px',
            filter: "alpha(opacity=" + opacity + ")",
            opacity: opacity / 100,
            position: 'fixed',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 100
        });
        backDiv.appendTo('body');
    }
}

//绑定事件
function refreshBind() {
    $(window).resize(function() {
        refreshBackground();
        refreshPop();
    });
    refreshBackground();
    refreshPop();
}

function refreshPop() {
    var divHeight = parseInt(popDiv.outerHeight());
    var divWidth = parseInt(popDiv.outerWidth());
    var divLeft = parseInt((document.documentElement.clientWidth - divWidth) / 2);

    var top = 0;
    top = document.body.scrollTop || document.documentElement.scrollTop + 50;
    var client_top = (document.documentElement.clientHeight - divHeight) / 2;

    var divTop = parseInt((top) + ((document.documentElement.clientHeight - divHeight) / 2));

    popDiv.css({
        position: 'fixed',
        top: client_top,
        left: divLeft,
        zIndex: 1002,
        marginLeft: 0,
        marginTop: 0
    });
}

function refreshBackground() {
    return
    if (backDiv) {
        var height = Math.max(document.body.scrollHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight);
        backDiv.width(Math.min(document.body.scrollWidth, document.documentElement.scrollWidth));
        backDiv.height(height);
    }
}

showmsg.exit = window.msgExit = exit;
module.exports = showmsg;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 * @封装用户会员各种信息文件
 * 需要在用户登录后才能调用这个文件，在访问接口asynProxy后调用有效
 * @author caizhenbo
 * create at 2015/4/11
 */

    var User = {};

    /**
     * 迅雷会员
     */
    User.isVip = function() {
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        if ((isvip == 1 || isvip == 2) && paytype < 1000) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 迅雷会员
     */
    User.isStopVip = function() {
        //return true;
        var isvip = parseInt(getCookie("vip_isvip"));
        if (isvip == 2) {
            return true;
        } else {
            return false;
        }

    }

    /***
     * 迅雷迷你会员
     */
    User.isMiniVip = function() {
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        if (this.isVip() && paytype < 1000 && vas_type == 1) {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 普通会员非白金
     */
    User.isNormalVip = function() {
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        if (this.isVip() && vas_type == 2) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 白金会员
     */
    User.isPlatinumVip = function() {
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        var level = parseInt(getCookie("vip_level"))
        if ((this.isVip() && vas_type == 3 ) || (this.isVip() && vas_type == 4 && level > 5 )) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 手机用户
     */
    User.isMobileVip = function() {
        var mobilevip = [3, 8, 9, 15, 103];
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        if (this.isVip() && vas_type <= 3 && _in_array(paytype, mobilevip)) {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 判断是否体验会员
     */
    User.isTiyan = function() {
        var isvip = getCookie('vip_isvip');
        var vip_paytype = getCookie('vip_paytype');
        if (this.isVip() == 1 && vip_paytype > 1000) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 判断是否钻石会员，先改为超级
     */
    User.isDiamondVip = function() {
        var isvip = getCookie('vip_isvip');
        var vas_type = getCookie('vas_type');
        if (this.isVip() == 1 && vas_type == 5) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 判断是否钻石会员
     */
    User.isSuperVip = function() {
        var isvip = getCookie('vip_isvip');
        var vas_type = getCookie('vas_type');
        if (this.isVip() == 1 && (vas_type == 5 || vas_type == 4)) {
            return true;
        } else {
            return false;
        }
    }


    /**
     * 判断是否快鸟会员
     */
    User.isKuainiaoVip = function() {
        var isvip = getCookie('vip_kn_isvip');
        return isvip == 1 ? true :false;
    }

    /**
     * 判断是否为过期会员
     */
    User.isOldvip = function() {
        var vip_level = getCookie("vip_level"); //会员级别;已登陆的非会员默认为0;
        var vip_isvip = getCookie("vip_isvip"); // 是否是 vip
        var vip_expiredate = getCookie("vip_expiredate") ;
        if (vip_level != null && vip_level != "" && vip_level != "0" && vip_isvip == 0) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * *
     * 判断是否是新用户
     */
     User.isNewUser = function(){
        var isVip = getCookie('vip_isvip'),
            level = getCookie('vip_level');
        if(isVip == 0 && level == '' || level == 0){
            return 1;
        }
        return 0 ;
    }

    /**
     * 判断是否为靓号
     */
    User.isGoodnum = function() {
        var vip_isgoodnum = getCookie("vip_is_good_number")
        if (vip_isgoodnum != null && vip_isgoodnum != "" && vip_isgoodnum == "1") {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 是否会员子帐号
     */
    User.isChild = function() {
        var ischild = parseInt(getCookie("ischild"));
        if (ischild == "1" || getCookie("vip_ischild") == 1) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 是否为年费会员
     */
    User.isYearVip = function() {
        var isyear = parseInt(getCookie("vip_isyear"));
        if (isyear == "1") {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 是否为2009年10月前购买白金会员的历史用户
     */
    User.isHistoryVip = function() {
        var ishistory = parseInt(getCookie("history"));
        if (ishistory == "1") {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 获取用户的昵称
     */
    User.nickname = function() {
        var nickname = getCookie("vip_nickname") ? getCookie("vip_nickname") : getCookie("usernick");
        return nickname;
    }

    /*
     *迅雷用户名
     */
    User.xlUsername = function() {
        var usrname = getCookie("usrname");
        var Usernewno = getCookie("Usernewno");
        if (usrname != '' && usrname != '0') {
            return usrname;
        }
        return Usernewno;

    }
    /**
     * 获取用户的头像
     */
    User.avatar = function() {

        return 'http://img.user.kanimg.com/usrimg/' + getCookie('userid') + '/100x100';
    }

    /**
     *用户的成长值
     */
    User.daily = function() {
        var daily = getCookie('vip_daily');
        return daily;
    }

    /**
     *用户等级
     *
     */
    User.level = function() {
        var level = getCookie('vip_level');
        if (level == 'level' || level == '') {
            level = 0;
        }
        return level;
    }

    /**
     * 用户图标url
     */
    User.iconUrl = function(){
        var iconUrl = '';
        if(User.isSuperVip()){
            iconUrl = 'http://vip.xunlei.com/vip_service/supervip/';
        }else{
            iconUrl = 'http://vip.xunlei.com/vip_service/mycenter/myvip.html';
        }
        return iconUrl;
    }

    /*
     **返回会员身份判断
     * return 0:非会员:1：迷你会员；2:普通会员；3：白金会员；4:钻石会员；
     */
    User.identity = function() {
        if (this.isMiniVip()) {
            return 1;
        }
        if (this.isNormalVip()) {
            return 2;
        }
        if (this.isPlatinumVip()) {
            return 3;
        }
        if (this.isDiamondVip()) {
            return 4;
        }
        if(this.isSuperVip()){
            return 5;
        }
        return 0;
    }

    /*
     **会员有效期
     */
    User.expiredate = function() {
        var expiredate = getCookie('vip_expiredate');
        if (expiredate) {
            return expiredate;
        } else {
            return '无';
        }
    }

    /*
     **用户会员图标
     **return 用户快鸟会员身份图标class
     */
     User.knIcon = function(){
        var iconClass = '';
        if (getCookie('vip_kn_isvip') == 1) {
            iconClass = 'icvip ickn';
        }else{
            iconClass = 'icvip icknhui';
        }

        return iconClass;
    }

    /*
     *用户会员图标
     * return 用户会员身份图标class
     */
    User.vipIcon = function(){
        var id = parseInt(getCookie('vas_type'));
        var level = this.level();
        var iconClass = '';
        switch(id){
            case 1:
               iconClass ='icvip icvip0'+ level + 'hui';
                break;
            case 2:
                iconClass ='icvip icvip0'+ level;
                break;
            case 3:
                iconClass ='icvip icgoldvip icgold0'+ level;
                break;
            case 4:
                if(level >= 6){
                    iconClass ='icvip icgoldvip icgold0'+ level;
                }else{
                    iconClass ='icvip icsuper0'+ level;
                }
                // iconClass ='icvip iczuan icz0'+ level;
                break;
            case 5:
                iconClass ='icvip icsuper0'+ level;
                break;
            default:
                iconClass ='icvip icvip0'+ level ;
                break;
        }
        if(getCookie('vip_isvip') == 0){
            //增加快鸟非会员显示快鸟图标
            iconClass = iconClass + 'hui';
        }
        return iconClass;
    }

    /*
     *用户会员身份
     * return 用户会员名称
     */
    User.vipName = function(){
        var name = '非会员';
        var id = parseInt(getCookie('vas_type'));
        var level = this.level();
        if(!User.isVip() && !User.isOldvip()){
            return name;
        }
        switch(id){
            case 1:
            case 2:
                name = '迅雷普通会员';
                break;
            case 3:
                if(level >= 6){
                    name = '迅雷白金钻石会员';
                }else{
                    name = '迅雷白金会员';
                }
                break;
            case 4:
                if(level >= 6){
                    name = '迅雷白金钻石会员';
                }else{
                    name = '迅雷超级会员';
                }
                // iconClass ='icvip iczuan icz0'+ level;
                break;
            case 5:
               name = '迅雷超级会员';
                break;
            default:
                name = '迅雷会员';
                break;
        }
        name = name + 'VIP' + level;
        if(getCookie('vip_isvip') == 0){

            name = '过期' + name ;
        }
        return name;
    }

    /*
     *用户到期时长剩余多少个月，向下取整
     * return 剩余月份
     */
    User.levelMonth = function(){
        var isVip = getCookie('vip_isvip'),
            expiredays = getCookie('vip_expiredays');
        if(isVip == 1){
            return Math.floor(expiredays/31);
        }
        return 0 ;
    }

    User.payText = function(){

        if(User.isStopVip()){
            return '激活会员';
        }
        return getCookie('pay_tips') || '开通白金会员';
    }

    function _in_array(val, arr) {
        for (var i in arr) {
            if (arr[i] == val) {
                return true;
            }
        }
        return false;
    }

    //initUserInfo();
    module.exports = User;


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var Util = {
	getSearch: function(key) {
		return new RegExp('[&?]' + key + '=([^&]*)', 'i').test(location.search) ? decodeURIComponent(RegExp.$1) : '';
	},
	isNull: function(a) {
		return typeof a == "object" && !a;
	},
	getUrlParam: function(url, parameter) {
		url = url || location.href;
		var result = url.match(new RegExp("[\#|\?]([^#]*)[\#|\?]?"));
		url = "&" + (this.isNull(result) ? "" : result[1]);
		result = url.match(new RegExp("&" + parameter + "=", "i"));
		return this.isNull(result) ? undefined : url.substr(result.index + 1).split("&")[0].split("=")[1];
	},
	initEvents: function(Events) {
		var key, keyArr, delElems, elems, events;
		var spiltElems = function(elems) {
			return elems.split('&').join(',');
		}
		for (key in Events) {
			keyArr = key.split('|');
			switch (keyArr.length) {
				case 3:
					delElems = spiltElems(keyArr[0]);
					elems = spiltElems(keyArr[1]);
					events = spiltElems(keyArr[2]);
					delElems = document;
					$(delElems).on(events, elems, Events[key]);
					break;
				case 2:
					elems = spiltElems(keyArr[0]);
					events = spiltElems(keyArr[1]);
					$(elems).on(events, Events[key]);
					break;
				default:
					break;
			}
		}
	},
	getType: function(obj){
		//console.log(obj)
		return (obj === null || obj === undefined) ? String(obj) : Object.prototype.toString.call(obj).match(/\[object (\w+)\]/)[1].toLowerCase()
	}
};
module.exports = Util;


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
__webpack_require__(12);
var isThunder = / Thunder/.test(navigator.userAgent);

$(function() {
	if (isThunder) {
		xl9.api.onUserLogout(function() {
			location.reload();
		});
		xlQuickLogin.setLoginExt(function(){

	    });
	} else {
		xlQuickLogin.init({
			loginID: '101',
			registerID: 'act',
			UI_THEME: 'popup',
			// 登录成功后回调函数，当 SET_ROOT_DOMAIN == true 时该项可用
			LOGIN_SUCCESS_FUNC: function() {
				window.loginInit();
			},
			// 注册成功后回调函数，当 SET_ROOT_DOMAIN == true 时该项可用
			REGISTER_SUCCESS_FUNC: function() {
				location.reload();
			},
			// 关闭按钮回调函数，只适用弹窗主题
			POPUP_CLOSE_FUNC: function() {},
			//登出后的回调
			LOGOUT_FUNC: function() {
				location.reload();
			}
		});
	}
});

function login() {
	if (isThunder) {
		xl9.api.showLoginDlg(function(err) {});
	} else {
		xlQuickLogin.popup();
	}
}

function haslogin() {
	return getRealCookie('sessionid') && getRealCookie('userid')
}

function logout() {
	clearCookie();
	if (isThunder) {
		xl9.api.logout(function(err) {

		});
	} else {
		xlQuickLogin.logout();
	}
}

$.live('.login', function() {
	login();
});

$.live('.logout', function() {
	logout();
});

window.haslogin = haslogin;
window.login = login;
window.logout = logout;
module.exports = {
	login: login,
	logout: logout,
	haslogin: haslogin
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

if (!window.active_cfg) {
    throw '配置文件不存在';
}

var login_config = {
    cookie_list: 'vip_nickname vip_usrname vip_growvalue vip_expiredate vip_level vip_isyear vip_paytype vip_isvip vip_daily vip_payname vip_is_good_number vip_num_is_open_vip vip_num_due_time vip_safebox vip_autopay act_cmb vas_type jsq_isvip jsq_expiredate ischild history vip_expiredays vip_kn_isvip vip_kn_level vip_kn_expiredate jsq_growvalue jsq_expiredate jsq_level jsq_paytype jsq_type jsq_score jsq_expiretype jsq_trialvip jsq_trialexpire'.split(' '),
    cookie_list_val: 'nickname usrname growvalue expiredate level isyear paytype isvip daily payname is_good_number num_is_open_vip num_due_time safebox autopay act_cmb vas_type jsq_isvip jsq_expiredate ischild history expiredays kn_isvip kn_level kn_expiredate jsq_growvalue jsq_expiredate jsq_level jsq_paytype jsqtype jsq_score jsq_expiretype jsq_trialvip jsq_trialexpire'.split(' ')
};

var $ = __webpack_require__(0);
$.live = function(selects, fn) {
    return $(document).on('click', selects, fn);
}

$.jsonp = function(url, data, callback) {
    if (typeof data === 'function') {
        callback = data;
        data = '';
    }

    var _callback = function(rs) {
        if (rs.result === -100) {
            clearCookie();
            logout();
            login();
        } else {
            callback(rs);
        }
    }

    return $.ajax({
        url: url,
        data: data,
        dataType: 'jsonp',
        success: _callback
    });
}

window.ajax = function(action, data, success, error) {
    if (!haslogin()) {
        login();
        return;
    }
    var url = 'http://dyactive2.vip.xunlei.com';
    if (typeof action !== 'string') {
        throw 'error action';
    }
    if (typeof data === 'function') {
        error = success;
        success = data;
        data = {};
    } else {
        data = data || {};
    }

    data.action = action;
    data.actid = active_cfg.base.actid;

    return $.ajax({
        url: 'http://dyactive2.vip.xunlei.com/iface/',
        dataType: 'jsonp',
        data: data,
        success: function(r) {
            if (r.result === -100) {
                clearCookie();
                logout();
                login();
            } else {
                success && success.call(this, r);
            }
        },
        error: error
    });
}

$.left = function(leftTime) {

    function checkTime(i) {
        if (i < 10) {
            i = "0" + i;
        } else {
            i = "" + i;
        }
        return i;
    }
    var days = parseInt(leftTime / 60 / 60 / 24, 10);
    var hours = parseInt(leftTime / 60 / 60 % 24, 10);
    var minutes = parseInt(leftTime / 60 % 60, 10);
    var seconds = parseInt(leftTime % 60, 10);
    days = checkTime(days);
    hours = checkTime(hours);
    minutes = checkTime(minutes);
    seconds = checkTime(seconds);
    return {
        d: days,
        h: hours,
        m: minutes,
        s: seconds
    }
}

var util = __webpack_require__(5);
var login = __webpack_require__(7);
var user = __webpack_require__(2);
var msgbox = __webpack_require__(1);
var renew = __webpack_require__(14);
var head = __webpack_require__(15);
__webpack_require__(16);
var actid = active_cfg.base.actid;
document.title = active_cfg.base.actname;
document.domain = 'xunlei.com';
var referfrom = util.getSearch('referfrom');

if (referfrom) {
    setRealCookie('referfrom', referfrom, undefined, 1);
}

function start() {
    if (location.host === 'vip.xunlei.com') {
        addNavAni();
    }
    bindEvents();
    init();
    if (login.haslogin()) {
        loginInit();
    } else {
        loginInit.fail && loginInit.fail();
    }
}

function addNavAni() {
    //导航动画
    function navGif(height, times, speed) {
        var _position = 0,
            _height = height * times * (-1),
            _interval;

        _interval = setInterval(function() {
            if (_position >= _height) {
                $(".vip-header .gif").css("background-position", "center " + _position + "px");
                _position -= speed;
            } else {
                $(".vip-header .gif").css("background", "none");
                clearInterval(_interval);
            }
        }, 100);
    }

    $(document).ready(function() {
        navGif(186, 3, 10);
    })
}

function setPageNav(index) {
    //页面导航
    if (index) {
        $('ul.menu li[index="' + index + '"]').addClass('cur');
    }
}

var autoAdaption = {
    run: function(){
        autoAdaption.adaption();
        $(window).resize(autoAdaption.adaption);
    },
    adaption: function () {
        //页面自适应
        var pw = $(window).width();
        if (pw <= 1000) {
            $("html").removeClass().addClass("w900");
        } else if (pw <= 1100) {
            $("html").removeClass().addClass("w1000");
        } else if (pw <= 1200) {
            $("html").removeClass().addClass("w1100");
        } else if (pw <= 1300) {
            $("html").removeClass().addClass("w1300");
        } else if (pw <= 1400) {
            $("html").removeClass().addClass("w1400");
        } else {
            $("html").removeClass();
        }
    }
};

function bindEvents() {
    $('#hd_index').on('mouseenter', '.vip-usertop', function() {
        $('#header-login .p_selfcon').show();
    }).on('mouseleave', '.vip-usertop', function() {
        $('#header-login .p_selfcon').hide();
    }).on('click', '[name="logout"]', function() {
        login.logout();
        return false;
    }).on('click', '[name="login"]', function() {
        login.login();
        return false;
    });

    //导航hover出二级菜单
    $(".vip-header .menu li").hover(function() {
        var subnav_ind = $(this).index();
        $(".subnav_wp").show();
        $(".subnav_wp .menu").hide();
        $(".subnav_wp").find(".subnav_" + subnav_ind).show();
    }, function() {
        $(".subnav_wp").hide();
    });
    $(".subnav_wp").hover(function() {
        $(this).show();
    }, function() {
        $(this).hide();
        $(".subnav_wp .menu").hide();;
    });
}

function init() {

    $.ajax({
        url: 'http://dyactive2.vip.xunlei.com/iface/?action=init&actid=' + actid,
        dataType: 'jsonp',
        success: function(r) {
            if (r.result == 0) {
                var data = r.data;
                r.data.message && msgbox.showErrorMsg(r.data.message);
                init.cb && init.cb(data);
            }
        }
    })
}

function onInit(fn) {
    init.cb = fn;
}

function loginInit() {
    var param = {
        userInfo: 1
    };

    if(location.host == 'act.jsq.xunlei.com'){
        param['jsqInfo'] = 1;
    }

    return $.ajax({
        url: 'http://dyactive2.vip.xunlei.com/iface/?action=logininit&actid=' + actid,
        dataType: 'jsonp',
        data: param,
        success: function(r) {
            if (r.result == 0) {
                var data = r.data;
                setUserInfo(data.userInfo);
                if (location.host === 'vip.xunlei.com') {
                    renew();
                }
                r.data.message && msgbox.showErrorMsg(r.data.message);
                loginInit.cb && loginInit.cb(data);
            } else if (r.result === -100) {
                clearCookie();
                loginInit.fail && loginInit.fail();
            }
        }
    })
}

function onLoginInit(fn, fn2) {
    loginInit.cb = fn;
    loginInit.fail = fn2;
}

var userInfo = {};

function setUserInfo(data) {
    if (data) {
        userInfo = data;

        var regcookie = function(cname, name) {
            if (data[name] != undefined) {
                //console.log('setCookie '+ cname + '  ' + data[name] + '  '+ name);
                setCookie(cname, data[name]);
            }


        };
        var cookie_list = login_config.cookie_list;
        var cookie_list_val = login_config.cookie_list_val;
        for (var i = 0, len = cookie_list.length; i < len; i++) {
            regcookie(cookie_list[i], cookie_list_val[i]);
        }
        head.init()
        //initHeader();
    }
}

window.loginInit = loginInit;
module.exports = {
    start: start,
    init: init,
    setPageNav: setPageNav,
    autoAdaption: autoAdaption.run,
    loginInit: loginInit,
    onInit: onInit,
    onLoginInit: onLoginInit
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(4);
var $ = __webpack_require__(0)
if (window.addEventListener) {
    window._k_report_error = [];
    window._k_report_options = {}
    window.addEventListener('error', function(e) {
        window._k_report_error.push(e);
        return true
    }, true)
};
if (!window.loggingPlugin) {
    window.loggingPlugin = {
        options: {
            app_name: 'K-Logging',
            open_level: ['info', 'warn', 'error'],
            method: ['', '', ''],
        },
        preDebug: [],
        prefInfo: [],
        prefWarn: [],
        prefError: [],
        listenerStatus: {},
        debug: function() {
            window.loggingPlugin.preDebug.push(arguments)
        },
        info: function() {
            window.loggingPlugin.prefInfo.push(arguments)
        },
        warn: function() {
            window.loggingPlugin.prefWarn.push(arguments)
        },
        error: function() {
            window.loggingPlugin.prefError.push(arguments)
        }
    }

    window.onerror = function(msg, url, lineNo, columnNo, error) {
        var string = msg.toLowerCase()
        var substring = 'script error'
        if (string.indexOf(substring) > -1) {
            window.loggingPlugin.error('Script Error: See Browser Console for Detail')
        } else {
            var message = [
                'Message: ' + msg,
                'URL: ' + url,
                'Line: ' + lineNo,
                'Column: ' + columnNo,
                'Error object: ' + JSON.stringify(error)
            ].join(' - ')

            window.loggingPlugin.error(message)
        }

        return false
    }

    var jqueryDocument = $ && $(document);
    if (jqueryDocument && jqueryDocument.ajaxComplete) {
        window.loggingPlugin.listenerStatus.jqueryAjax = true
        jQuery.ajaxPrefilter("script", function(s) {
            s.global = true;

        });
        jqueryDocument.ajaxComplete(function(event, request, settings) {
            if (!request) request = {}
            var result = {
                category: 'k-logging',
                name: 'jqueryAjaxComplete',
                data: {
                    url: settings.url,
                    responseJSON: request.responseJSON,
                    readyState: request.readyState,
                    status: request.status
                }
            }
            window.loggingPlugin.info(JSON.stringify(result))
        })
    }
}

__webpack_require__(10);
var tj = __webpack_require__(11);
var main = __webpack_require__(8);
var msgbox = __webpack_require__(1);
var user = __webpack_require__(2);
var login = __webpack_require__(7);
var util = __webpack_require__(5);
var logistics = __webpack_require__(17);
var vcode = __webpack_require__(20);

__webpack_require__(23);
__webpack_require__(24);

$(document).on('click', '.act_vip', function() {
    var payId = $(this).attr('payid');
    var payTitle = $(this).attr('paytitle');

    if (payId) {
        var payIds = {};
        var payIdArr = payId.split(',');
        if (payIdArr.length == 1) {
            pay(payId);
        } else if (payTitle) {
            var payTitleArr = payTitle.split(',');
            if (payIdArr.length == payTitleArr.length) {
                for (var i = 0, len = payIdArr.length; i < len; i++) {
                    payIds[payIdArr[i]] = payTitleArr[i];
                }
            }

            pay(payIdArr[0], payIds);
        }
    } else {
        pay();
    }
}).on('click', '.act_logistics', function() {
    logistics();
}).on('click', '.act_prize, act_prize_list', function() {
    prizelist();
}).on('click', '.act_address', function() {
    address();
}).on('click', '.act_info', function() {
    var gid = $(this).attr('gid');
    info(gid);
}).on('click', '.phone_message_get', function() {
    var gid = $(this).attr('gid') || null;
    var url = $(this).attr('data-url');
    var actid = $(this).attr('data-actid');
    vcode({
        gid: gid,
        url: url,
        actid: actid
    });
});

var pay = function(pid, pids) {
    __webpack_require__.e/* require.ensure */(1).then((function(require) {
        var pay = __webpack_require__(6);
        pay(pid, pids);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

pay.after = function(fn) {
    __webpack_require__.e/* require.ensure */(1).then((function(require) {
        var pay = __webpack_require__(6);
        pay.after(fn);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

var prizelist = function() {
    __webpack_require__.e/* require.ensure */(0).then((function(require) {
        var prizelist = __webpack_require__(3);
        prizelist();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

var address = function() {
    __webpack_require__.e/* require.ensure */(0).then((function(require) {
        var prizelist = __webpack_require__(3);
        prizelist.address();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

var info = function(gid) {
    __webpack_require__.e/* require.ensure */(0).then((function(require) {
        var prizelist = __webpack_require__(3);
        prizelist.info(gid);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

window.thunder = function(options, fn) {
    var allModules = {
        _: _,
        util: util,
        main: main,
        msgbox: msgbox,
        user: user,
        login: login,
        pay: pay,
        tj: tj.tj,
        xlaInit: tj.xlaInit,
        prizelist: prizelist,
        address: address,
        info: info,
        log: window.loggingPlugin
    };

    var optType = getOriginalType(options);
    if (optType === 'function') {
        fn = options;
    } else if (optType === 'object') {
        if (getOriginalType(options.thunderInit) === 'function') {
            // 各模块初始化
            options.thunderInit.call(allModules);
        }
    }

    if (!window.xla) {
        // 如果初始化中没有初始化这个，则需要自动初始化
        tj.xlaInit();
    }

    $(function() {
        fn.call(allModules);
        main.start();
        window.thunder === null;
    });
}

function getOriginalType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

window.domainList = {
    dyactive2: 'http://dyactive2.vip.xunlei.com',
    dyactive: 'http://dyactive.vip.xunlei.com',
    dyact: 'http://dyact.vip.xunlei.com',
    dynamic: 'http://dynamic.vip.xunlei.com',
    dypay: 'http://dypay.vip.xunlei.com',
    act: 'http://act.vip.xunlei.com',
    vip: 'http://vip.xunlei.com'
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

function xlaInit(appid, secret) {
	var xla = window.xla || (window.xla = []);
	xla.push({
		type: 'config',
		appid: appid || 20009,
		secret: secret || 'a8d1fc968b2fe1fe21bfe8f2abc4ba3a'
	});
	var s = document.createElement('script');
	s.src = '//res-etl-ssl.xunlei.com/v1.0.0/xla.min.js';
	s.async = true;
	document.getElementsByTagName('head')[0].appendChild(s);
}

(function() {
	var s = document.createElement("script");
	s.src = "//hm.baidu.com/hm.js?be94a17b28798d3dc61eb511641cdd9a";
	s.async = true;
	document.getElementsByTagName('head')[0].appendChild(s);
})();

(function() {
	if (window.addEventListener && window.console) {
		var s = document.createElement('script');
		s.src = 'https://img-vip-ssl.a.88cdn.com/lib/vip-report/1.0.0/vip-report.min.js';
		s.async = true;

		document.getElementsByTagName('head')[0].appendChild(s);
	}
	if (window.addEventListener && window.console) {
		var sLogging = document.createElement('script');
		sLogging.src = 'http://vip.xunlei.com/lib/vip-logging/1.1.2/vip-logging.js';
		sLogging.async = true;

		document.getElementsByTagName('head')[0].appendChild(sLogging);
	}
})();

function tj(id) {
	if (!id) {
		return;
	}
	window.habo_aid = id;
	var s = document.createElement('script');
	s.src = '/static/com/pv_click_v2.js';
	s.async = true;
	document.getElementsByTagName('head')[0].appendChild(s);
}

module.exports = {
	tj: tj,
	xlaInit: xlaInit
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var trim = function(x) {
    return x.toString().replace(/^\s|\s$/g, '');
}
var $ = __webpack_require__(0);
var COOKIE_DOMAIN = "vip.xunlei.com";
var CHILD_COOKIE_NAME = 'vipcookie';


if (window.location.href.indexOf('jsq.xunlei.com') != -1) {
    COOKIE_DOMAIN = 'jsq.xunlei.com';
    CHILD_COOKIE_NAME = "jsqcookie";
}

function setCookie(name, value, hours, isBaseDomain) {
    value = value + '';
    if (isBaseDomain != undefined && isBaseDomain == 1) {
        setRealCookie(name, value, hours, 1); //绑定到.xunlei中
    } else {
        var vipcookie = getRealCookie(CHILD_COOKIE_NAME);
        if (trim(value) == '') { //删除cookie
            if (vipcookie != '') {
                var check = getCookie(name);
                if (check != '') {
                    var cookies = vipcookie.split('&');
                    var newcookie = new Array;
                    for (var i = 0; i < cookies.length; i++) {
                        var ary = cookies[i].split('=');
                        if (ary.length > 1 && ary[0] != name) {
                            newcookie.push(cookies[i]);
                        }
                    }
                    vipcookie = newcookie.join('&');
                }
            }
        } else { //添加cookie
            //删除原生cookie中的此值
            setRealCookie(name, '', 0);
            if (vipcookie == '') {
                vipcookie = trim(name) + '=' + encodeURIComponent(value);
            } else {
                //check if has the same item , if so , replace it , otherwise add it.
                var check = getCookie(name);
                if (check != '') {
                    var cookies = vipcookie.split('&');
                    for (var i = 0; i < cookies.length; i++) {
                        var ary = cookies[i].split('=');
                        if (ary.length > 1 && ary[0] == name) {
                            cookies[i] = name + '=' + encodeURIComponent(value);
                            break;
                        }
                    }
                    vipcookie = cookies.join('&');
                } else {
                    vipcookie = vipcookie + '&' + trim(name) + '=' + encodeURIComponent(value);
                }
            }
        }
        if (hours != undefined) {
            setRealCookie(CHILD_COOKIE_NAME, vipcookie, hours);
        } else {
            setRealCookie(CHILD_COOKIE_NAME, vipcookie);
        }
    }
}

function setRealCookie(name, value, hours, isBaseDomain) {
    if (arguments.length > 2) {
        var expireDate = new Date(new Date().getTime() + hours * 3600000);
        if (isBaseDomain != undefined && isBaseDomain == 1) {
            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=xunlei.com; expires=" + expireDate.toGMTString();
        } else {
            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + COOKIE_DOMAIN + "; expires=" + expireDate.toGMTString();
        }
    } else {
        document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + COOKIE_DOMAIN;
    }
}

function getCookie(name) {
    var val = getRealCookie(name);
    if (trim(val) == '') {
        var vipcookie = getRealCookie(CHILD_COOKIE_NAME);
        if (trim(vipcookie) == '') {
            return '';
        }
        var cookies = vipcookie.split('&');
        for (var i = 0; i < cookies.length; i++) {
            var ary = cookies[i].split('=');
            if (ary.length > 1 && ary[0] == name) {
                return decodeURIComponent(ary[1]);
            }
        }
        return '';
    } else {
        return trim(val); //如果cookie中有该值，优先使用该值
    }
}

function getRealCookie(name) {
    return (document.cookie.match(new RegExp("(^" + name + "| " + name + ")=([^;]*)")) == null) ? "" : decodeURIComponent(RegExp.$2);
}

function clearCookie() {
    //清除子域名
    var ckeys = [CHILD_COOKIE_NAME, "vip_nickname", "ci_session", "vip_ci_session", "_x_a_", 'vip-xunlei-com-vipcookie', 'act-vip-xunlei-com-vipcookie'];
    for (var i = 0, len = ckeys.length; i < len; i++) {
        setRealCookie(ckeys[i], "", 0);
    }
    //主域名
    var ckeys1 = ["sessionid", "usrname", "unickname", "nickname", "usernick", "userid", "usertype", "usernewno", "blogresult", "score", "order", "isvip", "sex", "upgrade", "logintype", "checkans", "checkpwd", "jumpkey"];
    for (var i = 0, len = ckeys1.length; i < len; i++) {
        setRealCookie(ckeys1[i], "", 0, 1);
    }
}

window.setCookie = setCookie;
window.setRealCookie = setRealCookie;
window.getCookie = getCookie;
window.getRealCookie = getRealCookie;
window.clearCookie = clearCookie;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "<div class=\"act-pop-box\" style=\"display:none;\" id=\"act_msgbox_common\"><a href=\"javascript:msgExit();\" title=\"关闭\" class=\"act-pop-close act_close_box\">关闭</a><div class=\"act-pop-p-hd\"><h3 class=\"act-pop-p-titl\" name=boxTitle>温馨提示</h3></div><div class=\"act-pop-p-bd\" style=\"min-height:80px\"><p class=\"act-pop-p-sec\"><span name=\"msgbox_info\"></span></p></div><div class=\"act-pop-p-ft\"><a class=\"act-pop-btn act-pop-btn-hot\" href=\"javascript:msgExit();\" name=\"box_btn\">确定</a></div></div>"

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);

var _ = __webpack_require__(4);

var user = __webpack_require__(2);
var msgbox = __webpack_require__(1);
var orderInterval = null;
var orderCounter = 0;
var typeData = '';
var aidfrom = '';
var tipsid = '';

/*获取html片段*/
function getHtml(url, data, callback) {
    $.ajax({
        url: url,
        type: 'get',
        data: data,
        dataType: 'html'
    }).done(function(json) {
        callback(json);
    }).fail(function() {
        console.log("error");
    });
};

var typeConfig = {
    'originPay': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/original-pay.html',
        'heightClass': 'pop_460x460',
        'popid': 'hygw_tips_2'
    },
    'salePay': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/sale-pay.html',
        'heightClass': 'pop_460x460',
        'popid': 'hygw_tips_1'
    },
    'expiredMode1': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/expired-mode1.html',
        'heightClass': 'pop_460x460',
        'popid': 'hygw_tips_3'
    },
    'expiredMode2': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/expired-mode2.html',
        'heightClass': 'pop_480x480',
        'popid': 'hygw_tips_4'
    }
}


/*
 * 生成图片二维码
 */
function formSuperCode(data) {
    var imgSrc = 'http://m.pay.xunlei.com/vippay/qrcode?'
    for (var name in data) {
        imgSrc += name + '=' + data[name] + '&';
    }
    return imgSrc + '_v=' + new Date().getTime();
}

function formSuperCodeJson(data, callback) {
    var url = 'http://m.pay.xunlei.com/vippay/qrcode?';
    // for (var name in data) {
    //     url += name + '=' + data[name] + '&';
    // }

    $.ajax({
        type: "get",
        url: url,
        data: data,
        dataType: "jsonp",
        success: function(rs) {
            if (typeof callback == 'function') {
                callback(rs);
            }
        }
    });
}

/*
 * 获取交易id
 */
function setTradeId(month) {
    var vastype = getCookie('vas_type');
    var submitMonth = month >= 10 ? month : '0' + month;
    if(vastype == 5){
        return tradeid = '14' + submitMonth;
    }else{
        return tradeid = '11' + submitMonth;
    }
}

/*
 * 动作时间操作
 */
function initEvent(type) {
    $('#pay-list li').unbind().click(function(event) {
        $('#pay-list li').removeClass('cho');
        $(this).addClass('cho');
        showPriceAndGetCode($(this).attr('data-month'), $(this).attr('data-price'), 'v_pc_hygw_push_tips_center', type);

        /* Act on the event */
    });

    $('#renew-pop').on('click', '.link_refresh', function(){
        $('#pay-list').find('li.cho').click();
        $('#code-img').parent().find(".mask_off").hide();
    }).on('click', '.btn_red', function(){
        if(xla && xla.push){
            xla.push({
                type: 'event',
                category: 'hygw_centertips',
                action: 'centertips_click',
                extdata: {
                    pageid: typeData.popid,
                    tipsid: tipsid,
                    userid: getCookie('userid')
                }
            });
        }
    }).on('click', '.p_b_close', function(){
        if(xla && xla.push){
            xla.push({
                type: 'event',
                category: 'hygw_centertips',
                action: 'centertips_close',
                extdata: {
                    pageid: typeData.popid,
                    tipsid: tipsid,
                    userid: getCookie('userid')
                }
            });
        }
    }).on('click', '.link_otherpay', function(){
        if(getCookie('vas_type') == 5){  // 超级会员
            window.open('https://pay.xunlei.com/pay.html?bizNo=baijin&mref=116&selectBizno=baijin&timeType=1412&selectWay=qrcode&referfrom=v_pc_hygw_push_tips_center');
        }else{
            window.open('https://pay.xunlei.com/pay.html?bizNo=baijin&mref=116&selectBizno=baijin&timeType=1112&selectWay=qrcode&referfrom=v_pc_hygw_push_tips_center');
        }
    });
}

/*
 * 用户价格的显示
 */
function showPriceAndGetCode(month, money, referfrom, type) {
    // perMonth = (money / month).toFixed(1);
    perMonth = getCookie('vas_type') == 5 ? (month * 30 - money) : (month * 15 - money);
    $('#total-moeny').text(money + '元');
    $('#per-month').text('省' + perMonth + '元');
    if (type = 1) {
        var tradeid = setTradeId(month);
        var data = {
            qrcode: 1,
            version: 1.5,
            opid: 'web',
            pid: 'pc',
            userid: getCookie('userid'),
            sessionid: getCookie('sessionid'),
            mref: 105,
            referfrom: referfrom,
            days: '',
            tradeid: tradeid,
            auto: 0,
            aidfrom: aidfrom
        };

        // if(month == 12 && getCookie('vas_type') != 5){
        //     data = {
        //         'version': 'v2.0',
        //         'userid': getCookie('userid'),
        //         'sessionid': getCookie('sessionid'),
        //         'opid': 'web',
        //         'activeid': '2003001',
        //         'bizno': 'baijin',
        //         'num': '13',
        //         'rmb': '149',
        //         'ext2': $.param({
        //             actid: 'xl9minipage_bj',
        //             pid: 'bj13_149'
        //         }),
        //         '_v': (new Date()).getTime(),
        //         'mref': 105,
        //         'referfrom': referfrom,
        //         'aidfrom': aidfrom
        //     };
        // }
        formSuperCodeJson(data, function(rs){
            if (rs.data.code == 300) {
                $('#code-loading').hide();
                $('#code-img').attr('src', rs.data.qrcode).show();

                try {
                    clearInterval(orderInterval);
					orderCounter = 0;
					$('#code-img').parent().find(".mask_off").hide();
                } catch (e) {

                }

                orderInterval = setInterval(function() {
					orderCounter ++;
					if(orderCounter > 400){  // 400  超过20分钟，则不再发送请求
						clearInterval(orderInterval);
						$('#code-img').parent().find(".mask_off").show();
						return;
					}
                }, 3000);
            }
        });
    }
}

/*
 * 获取区间的类型
 */
function getType(day) {
    if (15 >= day && 10 <= day) {
        aidfrom = 'af_exp_10_15_qrcode';
        tipsid = 700007;
        return 1;
    } else if (9 >= day && 4 <= day) {
        aidfrom = 'af_exp_4_9_qrcode';
        tipsid = 700005;
        return 6;
    } else if (3 >= day && 1 <= day) {
        aidfrom = 'af_exp_1_3_qrcode';
        tipsid = 700004;
        return 2;
    } else if (0 == day) {
        aidfrom = 'bf_exp_0_qrcode';
        tipsid = 700003;
        return 3;
    } else if (-3 <= day && -1 >= day) {
        aidfrom = 'bf_exp_1_3_qrcode';
        tipsid = 700002;
        return 4;
    } else if (-9 <= day && -4 >= day) {
        aidfrom = 'bf_exp_4_9_qrcode';
        tipsid = 700006;
        return 5;
    } else if (-15 <= day && -10 >= day) {
        aidfrom = 'bf_exp_10_15_qrcode';
        tipsid = 700001;
        return 7;
    } else {
        return 0;
    }
}

function init() {
    var expiredays = getCookie('vip_expiredays'),
        type = getType(expiredays),
        isVip = getCookie('vip_isvip'),
        renewPop = getCookie('renew_pop_' + getCookie('userid')),
        popType;

    if(type == 0){
        return;
    }

    if (renewPop) {
        var renewCookieArry = renewPop && renewPop.split('_') || [];
        if (renewCookieArry[0] == isVip && renewCookieArry[1] == type) { //该规则配置下已经弹过弹窗
            return;
        } else {
            if (renewCookieArry[0] != isVip) {
                popType = getPopType(isVip);
            } else {
                popType = renewCookieArry[2]; //弹窗类型
            }
            showRenewPop(popType);
            setPopCookie(isVip, type, popType);
        }

    } else {
        popType = getPopType(isVip);
        showRenewPop(popType);
        setPopCookie(isVip, type, popType);
    }
}

/*
 * 用户显示弹窗
 */
function showRenewPop(type) {
    typeData = typeConfig[type];
    getHtml(typeData.url, {}, function(rs) {
        var tpl = rs;
        $('#renew-pop').addClass(typeData.heightClass).html((_.template(tpl))({
            'avatar': user.avatar(),
            'icon': user.vipIcon(),
            'nameClass': user.isVip() ? '#C80000' : '#383838',
            'userName': user.nickname(),
            'expiredays': Math.abs(getCookie('vip_expiredays')),
            'vastype': getCookie('vas_type')
        }));
        switch (type) {
            case 'originPay':
                initEvent(1);
                $('#pay-list li').eq(0).click();
                break;
            case 'salePay':
                showEndTime();
                initEvent(1);
                $('#pay-list li').eq(0).click();
                break;
            case 'expiredMode1':
                initEvent(1);
                $('#pay-list li').eq(0).click();
                break;
            case 'expiredMode2':
                initEvent();
                break;
        }
        // send_web_pv('adshow', {
        //     'clickid': typeData.popid
        // });
        msgbox.show('renew-pop');

        if(xla && xla.push){
            xla.push({
                type: 'event',
                category: 'hygw_centertips',
                action: 'centertips_show',
                extdata: {
                    pageid: typeData.popid,
                    tipsid: tipsid,
                    userid: getCookie('userid')
                }
            });
        }
    })
}

/*
 *设置弹窗的cookie
 *@isvip 会员身份
 *@type 显示的条件类型
 *@poptype显示的弹窗类型
 */
function setPopCookie(isvip, type, poptype) {
    setRealCookie('renew_pop_' + getCookie('userid'), isvip + '_' + type + '_' + poptype, 360);
}

/*
 * 随机显示弹窗浮层样式
 */
function getPopType(isvip) {
    var popType = '';
    if (isvip == 1) {
        popType = 'originPay';
    } else {
        popType = 'expiredMode1';
    }
    return popType;
}

/*
 *倒计时
 */
function showEndTime() {
    var ele = $('.countdown');
    var vipExpDate = new Date(getCookie('vip_expiredate').replace(/-/g, '/'));
    vipExpDate.setDate(vipExpDate.getDate() + 1);
    var expireTime = (vipExpDate.getTime() - new Date().getTime())/1000;
    var time = expireTime >= 0 ? expireTime : -1;
    var interval = ele.data('interval') || 1000;
    if (isNaN(time) || Math.floor(time) < 0) {
        clearTimeout(window.run);
        msgExit();
    } else {
        var dd = parseInt(time / 60 / 60 / 24);
        var hh = parseInt((time - dd * 24 * 3600) / 60 / 60);
        var mm = parseInt((time - dd * 24 * 3600 - hh * 3600) / 60);
        var ss = parseInt(time - dd * 24 * 3600 - hh * 3600 - mm * 60);
        var ms = parseInt(time * 100 - dd * 24 * 3600 * 100 - hh * 3600 * 100 - mm * 60 * 100 - ss * 100);
        dd = dd > 9 ? dd + '' : '0' + dd;
        hh = hh > 9 ? hh + '' : '0' + hh;
        mm = mm > 9 ? mm + '' : '0' + mm;
        ss = ss > 9 ? ss + '' : '0' + ss;
        ms = ms + '';
        if (ms.length == 1) {
            ms = '0' + ms;
        }

        ele.html('<span class="colon">还剩</span><span class="num"><i>' + dd +
            '</i></span><span class="colon">天</span><span class="num"><i>' + hh +
            '</i></span><span class="colon">时</span><span class="num"><i>' + mm + '</i></span><span class="colon">分</span>');
        time = (time * 1000 - interval) / 1000;
        time = time.toFixed(2);
        try {
            clearTimeout(window.run);
        } catch (e) {}
        window.run = setTimeout(function() {
            showEndTime();
        }, interval);
    }
}

module.exports = function() {
    if (haslogin() && Math.abs(getCookie('vip_expiredays') || 100) <= 15 && (getCookie('is_vip') == 1 || getCookie('is_vip') == 0)) {
        init();
    }
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
var user = __webpack_require__(2);
var _ = __webpack_require__(4);

var head = {
    init: function(){
         if (location.host === 'vip.xunlei.com') {
            head.vip()
         }else if(location.host === 'act.vip.xunlei.com'){
            head.knAndAct()
         }else if (location.host === 'act.jsq.xunlei.com'){
            head.JSQ()
         }
    },
    vip: function(){
        var loginTpl = $('#loginAfter_tpl').html();
        $('#header-unlogin').hide();
        var data = {
            'avatar': user.avatar(),
            'icon': user.vipIcon(),
            'vipName': user.vipName(),
            'iconUrl': user.iconUrl(),
            'nameClass': user.isVip() ? '#C80000' : '#383838',
            'userName': user.nickname(),
            'expireTip': getVipExpireTimeTip()
        }
        $('#header-login').html((_.template(loginTpl))(data)).show();
        $('.pay-vip').html(user.payText());

        //获取会员过期时间提示
        function getVipExpireTimeTip() {
            var expireDays = Math.abs(getCookie('vip_expiredays'));
            var tipStr;
            if (user.isStopVip()) {
                return '您的会员已暂停';
            }

            if (user.isMobileVip()) {
                return '您当前是手机包月会员';
            }

            if (user.isOldvip()) {
                if (expireDays < 30) {
                    tipStr = '过期会员成长值每日降10点';
                } else {
                    tipStr = '您的会员已过期';
                }
            } else if (user.isVip()) {
                if (expireDays == 0) {
                    tipStr = '你的会员今日到期，记得续费哦~';
                } else if (expireDays < 15) {
                    tipStr = '你的会员将于' + expireDays + '天后到期';
                } else {
                    tipStr = '会员有效期' + user.expiredate();
                }
            } else {
                tipStr = '点亮会员，尊享30多项特权';
            }
            return tipStr;

        }
    },
    knAndAct: function(){
        $('#header-unlogin').hide();
        var head = $('#header-login').show();
        $('#vip-icon').removeClass().addClass(user.vipIcon());
        head.find('em').find('a').eq(0).removeClass().addClass(user.isVip() ? 'username clr_red' : 'username').html('hi,' + user.nickname());
        head.find('img').attr('src', 'http://img.ucenter.xunlei.com/usrimg/' + getCookie('userid') + '/50x50');
        //兼容快鸟
        $('.j_header_userName').html(user.nickname());
        var timer;
        $('#header-login').hover(function(event) {
            timer && clearTimeout(timer);
            $(this).find('em.p_selfcon').show();
            return false;
        }, function(event) {
            timer = setTimeout(function() {
                $('em.p_selfcon').hide();
            }, 300)
        })
    },
    JSQ: function(){
        var _div = $("#div_header"),
            _span = $("#span_userinfo"),
            nickname = user.nickname() , //昵称
            userid = getCookie("userid"),
            userno = user.xlUsername(),
            jsq_growvalue = getCookie("jsq_growvalue") ? getCookie("jsq_growvalue") : 0,
            jsq_expiredate = getCookie("jsq_expiredate"),
            jsq_level = getCookie("jsq_level"),
            jsq_paytype = getCookie("jsq_paytype"),
            jsq_type = getCookie("jsq_type") ? getCookie("jsq_type") : 0,
            jsq_score = getCookie("jsq_score") ? getCookie("jsq_score") : 0,
            jsq_expiretype = getCookie("jsq_expiretype"),
            jsq_trialvip = getCookie("jsq_trialvip") ? getCookie("jsq_trialvip") : 0,
            jsq_trialexpire = getCookie("jsq_trialexpire") ? getCookie("jsq_trialexpire") : 0;
            // console.log(jsq_trialvip)
        function _init_info() {
            _div.find(".unlogin").hide(); //隐藏登录按钮
            _div.find(".logined").show(); //展示用户信息
            _div.find(".userinfo").hover(
                function() {
                    try {
                        clearTimeout(accountHoverTimer)
                    } catch (e) {};
                    _div.find(".infopop").show();
                    $(this).addClass('userinfo_hover');
                },
                function() {
                    $(this).removeClass('userinfo_hover');
                    accountHoverTimer = setTimeout(function() {
                        _div.find(".infopop").hide();
                    }, 50);
                });
        }

        function _isyear() {
            //年会员
            if (jsq_paytype == 5 || jsq_paytype == 105) {
                return true;
            } else {
                return false;
            }
        }


        function _init_pop() {
            var _grow, _nickname, _isyear, _tmp, _timeup = '',
                _icon;
            var _top = _div.find('.popcont .top');
            var _btm = _div.find('.popcont .btm');
            var _headimg = '<a href="http://dynamic.i.xunlei.com/user" target="_blank" title="" class="face spr_head"><img src="http://img.ucenter.xunlei.com/usrimg/' + userid + '/50x50" alt="" /></a>';
            var nicknameTitle = nickname;
            if (nickname.length > 5) {
                nickname = nickname.substring(0, 5) + '...';
            }
            _nickname = jsq_trialvip == 1 || jsq_type > 0 ? '<b >' + nickname + '</b>' : nickname;

            var _nickinfo = '<p title="' + nicknameTitle + '">亲爱的' + _nickname + '</p>';

            if (jsq_type > 0) {
                //会员
                if (jsq_type == 1) {
                    //高级会员
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl slv_icon slv' + jsq_level + '"></a></p>';
                    _icon = 'degree_icon svip' + jsq_level + ' fl';
                } else {
                    //普通会员
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl lv_icon lv' + jsq_level + '"></a></p>';
                    _icon = "degree_icon vip" + jsq_level + " fl";
                }
                _timeup += '<p class="time"><a href="http://vip.xunlei.com/vip_service/orderlist.html" target="_blank">' + jsq_expiredate + '到期</a></p>';
            } else {
                if (jsq_trialvip == 1) {
                    //体验会员
                    jsq_trialexpire = jsq_trialexpire.split(" ");
                    _timeup += '<p class="time"><a href="http://vip.xunlei.com/vip_service/orderlist.html" target="_blank">' + jsq_trialexpire[0] + '到期</a></p>';
                    $("#trialvip_icon").show();
                }

                //过期或非会员
                if (jsq_expiretype == 1) {
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl slvhui_icon slv' + jsq_level + '"></a></p>';
                    _icon = 'degreehui_icon svip' + jsq_level + ' fl';
                } else {
                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl lvhui_icon lv' + jsq_level + '"></a></p>';
                    _icon = 'degreeviphui_icon viphui' + jsq_level + ' fl';
                }
            }

            _tmp = _headimg + _nickinfo + _grow + _timeup;
            _top.html(_tmp);
            _span.removeClass().addClass(_icon);

            _div.find(".username").html(_nickname);
                        // alert(_nickname)
            $("#first_score").html(jsq_score);
            $("#first_grown").html(jsq_growvalue);
        }
         function _initDomInfo(){
              $('#act_nickname,.act_nickname,[name=act_nickname]').text(user.nickname());
              $('#act_userid,.act_userid,[name=act_userid]').text(getCookie('userid'));
              if(window.ACTCONFIG && window.ACTCONFIG.open_vip_link){
                  $('#header_open_vip_link').attr('href', window.ACTCONFIG.open_vip_link+'?referfrom='+referfrom);
              }
              $('.unlogin').hide();
              $('.logined').show();
            }


        _init_info();
        _init_pop();
        _initDomInfo();
    }
}

module.exports = head


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
$(document).on('mouseover', '.goerwei, .p_showma', function() {
    $('.p_showma').show();
    return false;
}).on('mouseout', '.goerwei, .p_showma', function() {
    $('.p_showma').hide();
    return false;
}).on('mouseenter', '.ic-wxgz,.ic-qqgz', function() {
    $(this).siblings('.p_wxcode').show();
    return false;
}).on('mouseleave', '.ic-wxgz,.ic-qqgz', function() {
    $(this).siblings('.p_wxcode').hide();
    return false;
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
var msgbox = __webpack_require__(1);
var logisticsId = 'act_logistics_popbox';
var tpl = __webpack_require__(18);
var template = __webpack_require__(19);
var list = [];
var totalLogisticsLength = 0;
var tips = '';
var l_status = false;
var actid = active_cfg.base.actid;

function LogisticsList(url) {
    if (!haslogin()) {
        login();
        return;
    }
    if (l_status) {
        return;
    }
    url = url || ('http://dyactive2.vip.xunlei.com/iface/?action=logininit&actid=' + actid);
    l_status = true;
    $.jsonp(url, function(rs) {
        l_status = false;
        var result = parseInt(rs.result);
        if (result == 0) {
            list = rs.data.prizelist || [];
            var listData = [];
            for (var k = 0, len = list.length; k < len; k++) {
                if (list[k]['fafang'] == "address") {
                    listData.push(list[k]);
                }
            }
            totalLogisticsLength = listData.length;
            var html = template.build(tpl)(listData);
            if (listData.length >= 0) {
                if (!$('#' + logisticsId).length) {
                    $('body').append(html);
                } else {
                    $('#' + logisticsId).replaceWith(html).show();
                }
                msgbox.show(logisticsId);
            }
        } else if (result == -100) {
            logout();
            login();
        } else {
            msgbox(rs.msg);
        }
    }, function() {
        l_status = false;
    });
}

$(document).on("click", "#act_logistics_popbox .turn_nav a", function() {
    var $this = $(this);
    if ($this.hasClass('disable')) {
        return;
    }

    var $curGoods = $("#act_logistics_popbox").find("div.cur_logistics");
    var idx = $curGoods.attr('index');
    idx = idx && Number(idx) || 0;

    if ($this.hasClass('prev')) {
        idx--;
        $curGoods.removeClass('cur_logistics').hide().prev().addClass('cur_logistics').show();
    } else if ($this.hasClass('next')) {
        idx++;
        $curGoods.removeClass('cur_logistics').hide().next().addClass('cur_logistics').show();
    }

    if (idx <= 0) {
        $this.parent().find("a.prev").addClass('disable');
    } else {
        $this.parent().find("a.prev").removeClass('disable');
    }

    if (idx >= totalLogisticsLength - 1) {
        $this.parent().find("a.next").addClass('disable');
    } else {
        $this.parent().find("a.next").removeClass('disable');
    }
});

module.exports = LogisticsList;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pop_logistics\" id=\"act_logistics_popbox\"><div class=\"pop_hd\"><p class=\"pop_tit\">我的物流</p><a href=\"javascript:msgExit();\" class=\"pop_close\" title=\"关闭\">X</a></div><div class=\"pop_cont\">{{if $d.length}}{{for $d}}<div class=\"{{$k < 1 ? \'cur_logistics\' : \'\'}}\" index=\"{{$k}}\" style=\"display: {{($k < 1 ? \'\' : \'none\') }};\"><dl><dt>奖品名称：</dt><dd class=\"tc_red\">{{for $v.tname.split(\"+\")}}<span class=\"award_name\">{{$v}}</span>{{/for}}</dd></dl><dl><dt>物流状态：</dt>{{if $v.keycode}}<dd class=\"tc_red\">已发货</dd>{{else}}<dd class=\"tc_red\">待发货</dd>{{/if}}</dl><dl><dt>承运来源：</dt>{{if $v.keycode }}<dd>{{$v.keycode.split(\',\')[0] }}</dd>{{else}}<dd>暂无</dd>{{/if}}</dl><dl><dt>运单编号：</dt>{{if $v.keypwd }}<dd>{{$v.keypwd }}</dd>{{else}}<dd>暂无</dd>{{/if}}</dl><dl><dt>官方电话：</dt>{{if $v.keycode && $v.keycode.split(\',\')[1]}}<dd>{{$v.keycode.split(\',\')[1]}}</dd>{{else}}<dd>暂无</dd>{{/if}}</dl></div>{{/for}}{{else}}<div><dl><dt>奖品名称：</dt><dd class=\"tc_red\"><span class=\"award_name\">暂无</span></dd></dl><dl><dt>物流状态：</dt><dd class=\"tc_red\">暂无</dd></dl><dl><dt>承运来源：</dt><dd>暂无</dd></dl><dl><dt>运单编号：</dt><dd>暂无</dd></dl><dl><dt>官方电话：</dt><dd>暂无</dd></dl></div>{{/if}}<a href=\"http://www.kuaidi100.com/?from=openv\" target=\"_blank\" class=\"link_query\">查看物流进展 &gt;&gt;</a><div class=\"turn_nav\" style=\"display: {{$d.length > 1 ? \'\' : \'none\'}};\"><a href=\"javascript:;\" class=\"prev disable\" title=\"上一页\">上一页</a><a href=\"javascript:;\" class=\"next\" title=\"下一页\">下一页</a></div></div></div>"

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var template = function(id) {
	return cache[id] || (cache[id] = build(getTpl(id)));
};

var cache = {};

var build = function(tpl){
	return function(data){
		var compiler = compile(tpl);
		return new compiler(data).toString();
	}
}

template.build = build;

var getTpl = function(id) {
	var el = document.getElementById(id);
	return el ? el.innerHTML : '';
}

var toString = function(value) {
	var type = typeof value;
	if (type !== 'string') {
		if (type === 'number') {
			value += '';
		} else if (type === 'function') {
			value = toString(value.call(value));
		} else {
			value = '';
		}
	}
	return value;
};

var escapeMap = {
	"<": "&#60;",
	">": "&#62;",
	'"': "&#34;",
	"'": "&#39;",
	"&": "&#38;"
};

var escapeFn = function(s) {
	return escapeMap[s];
};

var escape = function(content) {
	return toString(content).replace(/&(?![\w#]+;)|[<>"']/g, escapeFn);
};

var isArray = Array.isArray || function(obj) {
	return Object.prototype.toString.call(obj) === '[object Array]';
};

var each = function(data, callback) {
	var i, len, count = 0;
	if (isArray(data)) {
		for (i = 0, len = data.length; i < len; i++) {
			callback.call(data, data[i], i, data, i);
		}
	} else {
		for (i in data) {
			callback.call(data, data[i], i, data, count);
			count++;
		}
	}
};

var compile = template.compile = function(source, data) {

	var isNewEngine = ''.trim;
	var replaces = isNewEngine ? ["$o='';", "$o+=", ";", "$o"] : ["$o=[];", "$o.push(", ");", "$o.join('')"];
	var headerCode = "'use strict';var $e=this.$e,$f=this.$f,";
	var mainCode = replaces[0];
	var footerCode = "return new String(" + replaces[3] + ");"

	each(source.split("{{"), function(code, index) {
		code = code.split("}}");
		var $0 = code[0];
		var $1 = code[1];
		var len = code.length;
		if (code.length === 1) {
			mainCode += html($0);
		} else if (len === 2) {
			mainCode += logic($0);
			if ($1) {
				mainCode += html($1);
			}
		}
	});

	function stringify(code) {
		return "'" + code
			.replace(/('|\\)/g, '\\$1')
			.replace(/\r/g, '\\r')
			.replace(/\n/g, '\\n') + "'";
	}

	function html(code) {
		if (code) {
			code = replaces[1] + stringify(code) + replaces[2];
		}
		return code;
	}

	function logic(code) {
		code = code.replace(/^\s+|\s+$/, '');
		var split = code.split(/\s+/);
		var key = split.shift();
		var args = split.join(' ');
		switch (key) {
			case 'if':
				code = 'if(' + args + '){';
				break;

			case 'else':
				code = '}else{';
				break;

			case 'elseif':
				code = '}else if(' + args + '){';
				break;

			case '/if':
				code = '};';
				break;

			case 'for':
				split[0] = split[0] || '$d';
				split[1] = split[1] || '$v';
				split[2] = split[2] || '$k';
				code = '$f(' + split.shift() + ',function(' + split.join() + '){';
				break;

			case '/for':
				code = '});';
				break;

			case 'eval':
				code = args + ';';
				break;

			case '#':
				code = replaces[1] + "$e(" + code + ")" + replaces[2];
				break;

			default:
				code = replaces[1] + code + replaces[2];
				break;
		}
		return code;
	}
	var compiler = new Function("$d", headerCode + mainCode + footerCode);
	compiler.prototype.$e = escape;
	compiler.prototype.$f = each;
	return compiler;
}

module.exports = template;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
var msgbox = __webpack_require__(1);
var ajax = __webpack_require__(21);
var tpl = __webpack_require__(22);
var util = __webpack_require__(5);
var acturl = "http://dyactive2.vip.xunlei.com/iface/?action=getPrize";
var vcodeId = "act_verify_popbox";
var active_cfg = window.active_cfg;
var actid = '';
var percent = util.getUrlParam('percent') || '';
var pid = util.getUrlParam('pid') || '';
var sign = util.getUrlParam('sign') || '';
var arrParm = window.location.search.split('?').slice(1).join('&') || '';
var issubmit = false;
var user = __webpack_require__(2);
var VC = {
    keycode: '',
    show: function(keycode) {
        VC.keycode = keycode;
        if (!haslogin()) {
            login();
            return;
        }
        VC.refresh();
        msgbox.show(vcodeId);
        this.showTips('ok');
    },
    refresh: function() {
        $("#prize_verify").val('');
        $("#prize_verify_img").attr("src", "http://verify2.xunlei.com/image?t=MVA&" + Math.random());
    },
    send: function(gid, url, type) {

        var that = this;
        var code = $("#prize_verify").val();
        var gourl = '';
        if (code == '' && type == 'code') {
            that.showTips("请输入短信验证码");
            $("#prize_verify").focus();
        } else {
            if (issubmit == true) return;
            issubmit = true;
            that.sendBtn(issubmit);
            if (url) {
                gourl = url;
            } else {
                gourl = acturl + "&actid=" + actid + "&gid=" + gid + "&ver_code=" + code + "&" + arrParm;
            }

            if (type == 'check') {
                gourl += '&option=check';
                ajax(gourl, function(rs) {
                    var result = Number(rs.result);
                    issubmit = false;
                    that.sendBtn(issubmit);
                    if (result == 0) {

                        VC.init(gid, url, 'code');
                        VC.show(gid, url, 'code');
                        $('#code-mobile').text(rs.data.mobile);
                    } else {
                        msgbox.showErrorMsg(rs.msg);
                        that.showTips('ok');
                    }

                });
            } else {
                gourl += '&vermobile=' + code;
                ajax(gourl, function(rs) {
                    var result = Number(rs.result);
                    issubmit = false;
                    that.sendBtn(issubmit);
                    if (result == -100) {
                        showErrorMsg(rs.msg);
                    } else if (result == 0) {
                        var codeid = "success_" + rs.data.codeid;
                        var keycode = rs.data.keypwd == "" ? rs.data.keycode : rs.data.keycode + "/" + rs.data.keypwd;
                        $("#" + codeid).find('.keycode').html(keycode);
                        msgbox(rs.msg, {
                            btn_title: '查看奖品',
                            btn_href: 'javascript:;',
                            btn_class: 'act_prize'
                        });
                        loginInit();
                        that.sendCallback(rs);
                        that.showTips('ok');
                    } else if(result == -201){
                        msgbox('您已经领取过该奖品了哦，<a href="javascript:;" class="act_prize">查看我的奖品>></a>');
                    } else {
                        msgbox.showErrorMsg(rs.msg);
                        that.showTips('ok');
                    }
                });
            }

        }
    },
    sendCallback: function(data) {
        if ($.isFunction(window.ACTCONFIG.vcode_sendCallback)) {
            window.ACTCONFIG.vcode_sendCallback(data);
        }
    },
    init: function(gid, url, type) {
        var that = VC;
        if (!$('#' + vcodeId).length) {
            $('body').append(tpl);
        }

        $('#act_send_btn').off('click.submit').on('click.submit', function(event) {
            that.send(gid, url, type);
            return false;
        });
    },
    showTips: function(error) {
        if (error != 'ok') {
            $('#act_error_tips').text(error).show();
        } else {
            $('#act_error_tips').hide()
        }

    },
    sendBtn: function(issubmit) {
        //console.log(issubmit)
        if (issubmit == true) {

            $('#act_send_btn').text('提交中...');
        } else {
            $('#act_send_btn').text('提交');
        }
    },
    run: function(options){
        if (!haslogin()) {
            login();
            return false;
        }

        if (user.isChild()) {
            msgbox('抱歉，您使用的是迅雷子帐号，请使用主帐号来参加活动！');
            return false;
        }

        actid = options.actid || active_cfg.base.actid;
        var keycode = $(this).attr('keycode');

        VC.send(options.gid, options.url, 'check');
    }
};

function showErrorMsg(MSGID) {
    var MSG = active_cfg['msg'][MSGID];
    if (MSG) {
        var opts = {
            btn_title: MSG['btn_text'],
            btn_href: MSG['btn_link'],
            btn_target: MSG['btn_action'],
            boxTitle: MSG['title']
        };
        msgbox(MSG['content'], opts);
    } else {
        msgbox(MSGID);
    }
}

module.exports = VC.run;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);

function ajax(option, success, error) {
	var opt = {};
	typeof option === 'string' ? (opt.url = option) : typeof option === 'object' ? opt = option : 'ajax parameter error';
	success && (opt.success = success);
	error && (opt.error = error);
	opt.data = opt.data || {};
	opt.dataType = opt.dataType || 'jsonp';
	$.ajax(opt);
}
var _ajax = $.ajax;
$.ajax = function(opt) {
	opt.dataType = opt.dataType || 'jsonp';
	return _ajax(opt)
}
module.exports = ajax;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "<div class=\"act-pop-box\" style=\"display:none ;\" id=\"act_verify_popbox\"> <a href=\"javascript:msgExit();\" title=\"关闭\" class=\"act-pop-close\">关闭</a> <div class=\"act-pop-panel\"> <div class=\"act-pop-p-hd\"><h3 class=\"act-pop-p-titl\">填写验证码</h3></div> <div class=\"act-pop-p-bd\" style=\"min-height:0px\"> <p class=\"act-pop-p-sec\">请填写发送到您手机号<span id=\"code-mobile\" class=\"c_red\"></span>上的验证码</p> <form class=\"act-pop-form\"> <div class=\"act-pop-fm-group\"> <label class=\"act-pop-fm-label\">验证码:</label> <div class=\"act-pop-fm-content\"> <input type=\"text\" tabindex=\"5\" id=\"prize_verify\" maxlength=\"6\"> <p class=\"act-pop-fm-tip\" id=\"act_error_tips\">请输入验证码</p> </div> </div> </form> </div> <div class=\"act-pop-p-ft\"> <a class=\"act-pop-btn act-pop-btn-hot\" href=\"javascript:void(0)\" id=\"act_send_btn\">提交</a> <a class=\"act-pop-btn act-pop-btn-info\" href=\"javascript:msgExit();\">取消</a> </div> </div></div>"

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
var msgbox = __webpack_require__(1);
var actid = active_cfg.base.actid;
var msg_cofig = {
    "address": {
        opts: {
            btn_title: "填写资料",
            btn_href: "javascript:void(0);",
            btn_target: "0",
            boxTitle: "恭喜亲中奖啦！",
            btn_class: "act_address"
        }
    },
    "info": {
        opts: {
            btn_title: "我的收货地址",
            btn_href: "javascript:void(0);",
            btn_target: "0",
            boxTitle: "恭喜亲中奖啦！",
            btn_class: "act_qq_sub",
        }
    },
    "virtual": {
        successCallback: function(rs){
            if (rs.result == 0 && rs.data.tname ) {
                msgbox('恭喜获得了' + rs.data.tname + '!', {
                    btn_title: "我知道了",
                    btn_href: "javascript:void(0);",
                    btn_target: "0",
                    btn_fn :function(){
                        msgbox.exit();
                    }
                })
            }else {
                 msgbox.showErrorMsg(rs.msg, msg_cofig[rs.data.fafang]['opts']);
            }
            
        }
    }
}

$.fn.lottery = function(_config) {
    var config = {
        giftItem: 'li', //单个奖品选择器
        sort: [0, 1, 2, 7, 3, 6, 5, 4], //排序，默认为顺序
        targetClass: 'on', //选中时的class，默认on
        fastSpeed: 80, //快速阶段的速度(定时器时间间隔)，默认80
        slowSpeed: 444, //慢速阶段的速度(定时器时间间隔)，默认400
        startStep: 5, //开头的慢速阶段跑几步，默认4
        endStep: 6, //结束的慢速阶段跑几步，默认4
        startBtn: '.start_btn',
        lottery_url: location.protocol + '//dyactive2.vip.xunlei.com/iface/?action=getLottery&actid=', //获取抽奖结果的url
        ani: true,
        lotteryAfter: null,
        gid: ''
    };

    $.extend(config, _config);

    var islottery;
    var timeIntervalId; //定时器
    var curStatus; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
    var giftIndex; //抽中奖品的位置,-1表示还没获得
    var curIndex; //当前在哪个位置
    var runCount; //累计总共跑了几个位置
    var endCallback; //用来注册结束时回调的函数
    function reset() {
        curStatus = 0; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
        giftIndex = -1; //抽中奖品的位置,-1表示还没获得
        curIndex = 0; //当前在哪个位置
        runCount = 0; //累计总共跑了几个位置
    }
    reset();

    var $lotteryBox = this.eq(0);
    var giftCount = $lotteryBox.find(config.giftItem).length; //奖品总数
    var idx = 0;
    if (!config.sort || config.sort.length != giftCount) {
        $lotteryBox.find(config.giftItem).each(function() {
            $(this).attr('sort', idx);
            idx++;
        });
    } else {
        $lotteryBox.find(config.giftItem).each(function() {
            $(this).attr('sort', config.sort[idx]);
            idx++;
        });
    }

    function run() {
        reset();
        focusToNext();
        curStatus = 1; //开始
        myInterval(config.slowSpeed);
    }

    //设置定时器，私有函数
    function myInterval(speed) {
        clearInterval(timeIntervalId);
        timeIntervalId = setInterval(function() {
            runCount++;
            curIndex = runCount % giftCount;
            focusToNext();
            stepFunction();
        }, speed);
    }

    //设置当前dom状态，私有函数
    function focusToNext() {
        $lotteryBox.find(config.giftItem).removeClass(config.targetClass);
        $lotteryBox.find(config.giftItem + '[sort=' + curIndex + ']').eq(0).addClass(config.targetClass);
    }

    //每跑一步检测当前状态，私有函数
    function stepFunction() {
        if (curStatus == 1 && runCount == config.startStep) {
            curStatus = 2; //加速
            myInterval(config.fastSpeed);
        }
        if (curStatus == 2 && (runCount >= (config.startStep + giftCount * 2))) { //至少要快速跑一圈
            if (giftIndex != -1) {
                var needNum = giftCount - config.endStep - (curIndex - giftIndex);
                if (needNum == 0 || needNum == giftCount) {
                    curStatus = 3; //中奖减速阶段
                    myInterval(config.slowSpeed);
                }
            }
        }
        if (curStatus == 3 && curIndex == giftIndex) {
            end();
        }
    }

    function end() {
        clearInterval(timeIntervalId);
        setTimeout(function() {
            endCallback && endCallback();
        }, 200);
    }

    function setGift(_giftIndex, _endCallback) {
        reset();
        giftIndex = parseInt(_giftIndex);
        endCallback = _endCallback;
        //以下mzk修改
        //run();

        focusToNext();
        curStatus = 1; //开始
        myInterval(config.slowSpeed);
    }

    function afterLottery(rs) {
        if (config.after && (config.after(rs) === false)) {
            return;
        }
        if (msg_cofig[rs.data.fafang]) {
            if (msg_cofig[rs.data.fafang].successCallback){
                msg_cofig[rs.data.fafang].successCallback(rs)
            }else {
                msgbox.showErrorMsg(rs.msg, msg_cofig[rs.data.fafang]['opts']);
            }
        } else {
            msgbox.showErrorMsg(rs.msg);
        }
    }

    function start() {
        if (islottery) return;
        islottery = true;
        $.jsonp(config.lottery_url, {
            actid: actid,
            gid: config.gid
        }, function(rs) {
            if (config.before && (config.before(rs) === false)) {
                islottery = false;
                return;
            }
            if (rs.result == 0) {
                if (config.ani) {
                    setGift(rs.data.frontid, function() {
                        afterLottery(rs);
                        islottery = false;
                    });
                } else {
                    afterLottery(rs);
                    islottery = false;
                }
            } else {
                msgbox.showErrorMsg(rs.msg);
                islottery = false;
            }
        });
    }
    $(config.startBtn).off('click').on('click', function() {
        if (!haslogin()) {
            login();
            return false;
        }

        start();
    });
    return {
        start: start
    };
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);

$.fn.textSlider = function(set) {
	var config = $.extend({
		direction: 'top',
		speed: 2000,
		wait : 1000,
		child: 'ul',
		line: 1,
		per: 1
	}, set);
	return this.each(function() {
		$.fn.textSlider.scllor($(this), config);
	});
};
$.fn.textSlider.scllor = function($this, config) {
	var wrap = $this.find(config.child).eq(0);
	var timer;
	var sub = wrap.children();
	if(sub.length === 0) {
		return;
	}
	var auto = true;
	config.sub = sub.get(0).tagName.toLocaleString();
	var liHight, upHeight, liWigth, leftWidth;
	var ing = false;
	var scrollUp = function() {
		liHight = 0;
		upHeight = 0;
		for (var i = 0; i < config.line; i++) {
			liHight = wrap.children().eq(i * config.per).outerHeight(true);
			upHeight = upHeight - liHight;
		}
		ing = true;
		wrap.animate({
			marginTop: upHeight
		}, config.speed, function() {
			wrap.find(config.sub + ':lt(' + config.per * config.line + ')').appendTo(wrap);
			wrap.css({
				marginTop: 0
			});
			ing = false;
			auto && (timer = setTimeout(scrollUp, config.wait));
		});
	};

	var scrollLeft = function() {
		liWigth = 0;
		leftWidth = 0;
		for (var i = 0; i < config.line; i++) {
			liWigth = wrap.children().eq(i * config.per).outerWidth(true);
			leftWidth = leftWidth - liWigth;
		}
		ing = true;
		wrap.animate({
			marginLeft: leftWidth
		}, config.speed, function() {
			wrap.find(config.sub + ':lt(' + config.per * config.line + ')').appendTo(wrap);
			wrap.css({
				marginLeft: 0
			});
			ing = false;
			auto && (timer = setTimeout(scrollLeft, config.wait));
		});
	};

	var bottom = function() {
		liWigth = 0;
		leftWidth = 0;
		var all = wrap.children().length;
		var _top = 0;
		$.each(wrap.children(), function() {

		})
		for (var i = 0; i < config.line; i++) {
			liWigth = wrap.children().eq(i * config.per).outerWidth(true);
			leftWidth = leftWidth - liWigth;
		}
		ing = true;
		wrap.animate({
			marginLeft: leftWidth
		}, config.speed, function() {
			wrap.find(config.sub + ':lt(' + config.per * config.line + ')').appendTo(wrap);
			wrap.css({
				marginLeft: 0
			});
			ing = false;
			auto && (timer = setTimeout(scrollLeft, config.wait));
		});
	};
	var fn;
	switch(config.direction) {
		case 'left':
			fn = scrollLeft;
			break;
		case 'bottom':
			fn = bottom;
			break;
		default:
			fn = scrollUp;
	}
	var autoPlay = function() {
		auto = true;
		if(!ing) {
			timer = setTimeout(fn, config.wait);
		}
	};
	var autoStop = function() {
		auto = false;
		clearTimeout(timer);
	};
	if(!('ontouchstart' in window)) {
		$this.hover(autoStop, autoPlay);
	}
	fn();
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// thunder.min.js